export { default as SgLoadingAnimation } from './sg-loading-animation.png';
